export default __webpack_public_path__ + "static/media/info-img8.000d538a.png";